import { OrderTablePage } from "./orderTable/OrderTablePage";
import { OrderFilterPage } from "./orderFilter/OrderFilterPage";
import classes from "./orderPage.module.css";

export const OrderPage = () => {
  return (
    <div className={classes.box}>
      <OrderFilterPage />
      <OrderTablePage />
    </div>
  );
};
